import { createConsts, createActions } from '../../utils/redux';

export const consts = createConsts('ui', 'online', 'SET_ONLINE');
export const actions = createActions(consts);

export default (state = true, action) => {
  switch (action.type) {
    case consts.SET_ONLINE:
      return action.payload;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/ui/online.js